<div class="flex flex-col external-package h-100-percent">
    <div class="flex flex-row justify-between">
      <div class="mat-headline-6 mb-0">{{'INSTANCE_DETAILS.UPDATE_BUILD.ADD_DEPENDENT' | transloco }}</div>
      <mat-icon svgIcon="close" class="cursor-pointer" (click)="sidenavService.closeRightSidenav()"></mat-icon>
    </div>
    <mat-divider class="neutral-blue-6 mt-16 mb-24"></mat-divider>
    <div *ngFor="let option of missingDependency">
        <div class="flex flex-row mr-20 ">
          <span class="mt-4">{{option | titlecase}}</span>
        </div>
      </div>
    <span class="flex-auto"></span>
    <mat-divider class="neutral-blue-6 mt-24 mb-24"></mat-divider>
  <div class="footer" >
    <div class="flex flex-row justify-end gap-x-6">
      <button class="white" type="button" (click)="sidenavService.closeRightSidenav()">{{'BUTTONS.CANCEL' | transloco}}</button>
    </div>
  </div>
</div>